<template>
  <div>
    <Form
      ref="formValidate"
      :model="formValidate"
      :rules="ruleValidate"
      :label-width="80"
    >
      <FormItem label="所属标签" prop="tag_id" >
        <Select v-model="formValidate.tag_id">
          <Option
            v-for="item in tagIds"
            :value="item.id"
            :key="item.id"
            >{{ item.name}}</Option
          >
        </Select>
      </FormItem>

      <FormItem style="text-align: right">
        <Button @click="handleReset('formValidate')">重置</Button>
        <Button
          type="primary"
          @click="handleSubmit('formValidate')"
          style="margin-left: 8px"
          >提交</Button
        >
      </FormItem>
    </Form>
  </div>
</template>

<script>
import params from '../argu-page/params.vue'
export default {
  components: { params },
  props: {
    resetFlag: {
      type: Boolean,
      default: false
    },
    editData: {
      type: Object,
      default: () => {}
    },
    edit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      classifyIds: [],
      tagIds:[],
      liveTypes:[],
      formValidate: {
        id: '',
        tag_id:''
      },
      ruleValidate: {
        classify: [
          {
            required: true,
            message: '所属分类必须要选择',
            trigger: 'change'
          }
        ],
        tag_id: [
          {
            required: true,
            message: '标签必须要选择',
            trigger: 'change'
          }
        ],        
        live_id: [
          {
            required: true,
            message: '平台必须要选择',
            trigger: 'change'
          }
        ],
      }
    }
  },
  watch: {
    resetFlag (resetFlag) {
      this.handleReset('formValidate')
    }
  },
  methods: {
    setTagData(tagData){
      this.tagIds = tagData
    },
    setEditData (data) {
      this.formValidate.id = data.id
      this.formValidate.tag_id = data.tag_id.toString()
    },
    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$emit('on-ok', this.formValidate)
        } else {
          this.$Message.error('失败!')
        }
      })
    },
    handleReset (name) {
      this.$refs[name].resetFields()
    }
  }
}
</script>
